import { renderToString } from 'react-dom/server'

const columns = [
  {
    data: "name",
    width: "20%",
    className: "bold",
    render: function(data, type, row, meta) {
      return renderToString(
        <a href={row['url_path']}>{data}</a>
      )
    }
  },
  {data: "url", width: "40%", render: (data) => renderToString(<span>{data}</span>)},
  {
    data: "topics",
    width: "30%",
    render: function(data, type, row, meta) {
      if (data) {
        return renderToString(
          <span>{data.split(', ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(', ').replace(/_/g, ' ')}</span>
        )
      }
      return data
    }
  },
  {
    data: "active",
    width: "10%",
    render: function(data, type, row, meta) {
      data = data.toLowerCase()
      return renderToString(
        <span>{data === 'true' ? 'Yes' : 'No'}</span>
      )
    }
  },
]

const headers = [
  'Name',
  'URL',
  'Topics',
  'Active',
]

const filters = [
]

const sorters = [
]

const order = [[ 0, "asc" ]]

export { columns, headers, filters, sorters, order }
